import { Component, Input, Output, EventEmitter } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'cm-icon-button',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule],
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
})
export class CmIconButtonComponent {
  @Input() imgSrc?: string;
  @Input() icon?: string;
  @Input() alt?: string;
  @Input() active = false;
  @Input() disabled = false;
  @Output() onClick = new EventEmitter<MouseEvent>();

  handleClick(e: MouseEvent): void {
    if (!this.disabled) this.onClick.emit(e);
  }
}
